<template>
  <div class="gmb-attributes-tree-node">
    <div class="group-name">{{ groupName }}</div>
    <div class="items">
      <template v-for="service in services">
        <div class="item" :key="service.service_type_id">
          <GmbServicesItemBool
            :service="service"
            :delete-mode="deleteMode"
            @add-description="showDescriptionDialog(service)"
            @input="handleSelectedValue(service, $event)"
          />
        </div>
      </template>
    </div>
    <v-dialog
      v-if="showDialog"
      v-model="showDialog"
      width="500"
      :close-on-esc="false"
      :close-on-click-outside="false"
      content-class="gmb-attributes-tree"
    >
      <v-card>
        <v-card-title :title="selectedServices.display_name">
          <span>{{ selectedServices.display_name }}</span>
        </v-card-title>
        <v-card-text>
          <v-textarea
            v-model="selectedServices.description"
            :label="$t('message.common.description')"
            :rules="[validateDescription]"
            rows="5"
            counter="300"
            no-resize
          ></v-textarea>
        </v-card-text>
        <v-card-actions class="justify-center">
          <ui-button @click="showDialog = false">{{
            $t("message.common.cancel")
          }}</ui-button>
          <ui-button
            @click="addDescription"
            :disabled="isFromButtonDisabled"
            color="primary"
            >{{ $t("message.common.add") }}</ui-button
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { GmbAttributeValueType } from "@/enums/gmb-attribute-value-type";
import GmbServicesItemBool from "@/components/FacilityDetails/GmbServices/GmbServicesItemBool";

export default {
  name: "GmbServicesTreeNode",
  components: {
    GmbServicesItemBool
  },
  props: {
    groupName: {
      type: String,
      required: true
    },
    services: {
      type: Array,
      required: true
    },
    deleteMode: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      valueType: GmbAttributeValueType,
      selectedServices: {},
      showDialog: false,
      isFromButtonDisabled: false
    };
  },
  methods: {
    validateDescription(value) {
      const isValid = (value || "").length <= 300;
      if (!isValid) {
        this.isFromButtonDisabled = true;

        return this.$t(
          "message.facilityDetails.services.validation.descriptionLength",
          ["300"]
        );
      }
      this.isFromButtonDisabled = false;

      return isValid;
    },
    handleSelectedValue(service, value) {
      this.selectedServices = { ...service, value };
      this.$emit("input", this.selectedServices);
    },
    showDescriptionDialog(service) {
      this.selectedServices = JSON.parse(JSON.stringify(service));
      this.showDialog = !this.showDialog;
    },
    addDescription() {
      this.showDialog = false;
      const service = this.services.find(
        service =>
          service.service_type_id === this.selectedServices.service_type_id
      );
      if (service) {
        service.description = this.selectedServices.description;
      }

      this.$emit("update", this.selectedServices);
    }
  }
};
</script>

<style lang="scss" scoped>
$paddingX: 68px;
$shadow: 0 0 12px rgba(0, 0, 0, 0.05);

.gmb-attributes-tree-node {
  padding-top: 20px;
  padding-bottom: 15px;

  &:not(:last-of-type) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.07);
  }
}

.group-name {
  font-weight: 600;
  @include font-size(16px);
  line-height: 20px;
  color: $grey-darker;
  margin-bottom: $spacing * 1.25;
}
.gmb-attributes-tree {
  .v-card {
    .v-card__title {
      @include font-size(18px);
      font-weight: 600;
      line-height: 22px;
      justify-content: center;
      padding-left: $spacing * 5 !important;
      padding-right: $spacing * 5 !important;

      span {
        white-space: nowrap;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .v-card__title,
    .v-card__actions {
      padding: 20px $paddingX;
      box-shadow: $shadow;
      z-index: 1;

      .v-btn {
        flex-grow: 1;
      }
    }

    .v-card__text {
      padding-left: $spacing * 5;
      padding-right: $spacing * 5;
      position: relative;
    }
  }

  .search-input {
    width: 100%;

    .theme--light.v-label {
      color: rgba(54, 60, 86, 0.35);
      font-weight: 400;
    }

    &.v-text-field > .v-input__control > .v-input__slot {
      font-weight: 500;
    }
  }

  .dialog-message {
    @include font-size(14px);
    line-height: 17px;
    text-align: center;
    color: $grey-darker;
    opacity: 0.8;
    font-weight: 400;
    word-break: normal;
    margin: $spacing * 1.25 $spacing * -5;
  }
}
</style>
